import React, { useState, useEffect } from 'react';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { useParams } from 'react-router-dom';
import { getCustomerV2 } from 'utils/CustomersAPIUtils';
import CustomersActionCreators from 'actions/CustomersActionCreators';
import CarrierDriverWebAPIUtils from 'utils/CarrierDriverWebAPIUtils';
import DriverStore from 'stores/DriverStore';
import Sidebar from 'components/modules/carrier/AdminSidebar';
import Spinner from 'components/ui/Spinner';
import DriverList from 'components/modules/user/carrier/driver-list';
import AddDriverModal from 'components/modules/user/carrier/add-driver-modal';
import { useTranslation } from 'react-i18next';

const Loading = function () {
  return (
    <div className="justify-center lg:col-span-1" style={{ top: '50%' }}>
      <div className="align-middle">
        <span className="text-5xl text-green">
          <Spinner showMessage={false} />
        </span>
      </div>
    </div>
  );
};

const DriversSettings = () => {
  const { t } = useTranslation();
  const [carrier, setCarrier] = useState(null);
  const [drivers, setDrivers] = useState(null);
  const [showAddDriverModal, setShowAddDriverModal] = useState(false);
  const params = useParams();
  const carrierId = params.id;
  const renderSidebar = () => (
    <Sidebar userId={carrierId} activePage="drivers" />
  );

  const fetchDrivers = () => {
    const drivers = DriverStore.getAllDrivers();

    if (drivers) {
      setDrivers(
        drivers.slice().sort((a, b) => {
          if (a.first_name && b.first_name)
            return a.first_name.toLowerCase() < b.first_name.toLowerCase()
              ? -1
              : 1;
          return -1;
        }),
      );
    }
  };

  useEffect(() => {
    DriverStore.addChangeListener(fetchDrivers);
    fetchUser();

    return () => {
      DriverStore.removeChangeListener(fetchDrivers);
    };
  }, []);

  const breadcrumbs = {
    pages: [
      {
        name: carrier?.name || t('CARRIER'),
        href: `/users/${carrierId}`,
        current: false,
      },
      {
        name: 'Drivers',
        href: `/users/${carrierId}/carrier-settings/drivers`,
        current: true,
      },
    ],
  };

  const handleAddDefaultDriver = () => {
    CustomersActionCreators.createDefaultDriver(carrier._id);
  };

  const handleUpdateDriver = (data) => {
    CustomersActionCreators.updateDriver(data);
  };

  const handleAddCarrierDriver = (data) => {
    CustomersActionCreators.createDriver(data);
  };

  const handleMakeDriverDefault = (driverId) => {
    const update = Object.assign({}, carrier, {
      default_driver: driverId,
    });
    CustomersActionCreators.updateCarrier(update);
  };

  const fetchUser = async () => {
    const user = await getCustomerV2(carrierId);
    setCarrier(user);
  };

  useEffect(() => {
    CarrierDriverWebAPIUtils.getAllDrivers(carrierId);
  }, []);

  return (
    <LayoutWithSidebar
      sidebar={renderSidebar}
      breadcrumbs={breadcrumbs}
      className="py-4"
    >
      {carrier && drivers ? (
        <>
          <DriverList
            onAdd={() => setShowAddDriverModal(true)}
            onAddDefaultDriver={handleAddDefaultDriver}
            carrier={(
              (carrier.name[0] || '').toUpperCase() +
              (carrier.name.slice(1) || '')
            ).trim()}
            drivers={drivers}
            onUpdateDriver={handleUpdateDriver}
            defaultDriver={
              carrier.default_driver ? carrier.default_driver._id : null
            }
            onMakeDefault={handleMakeDriverDefault}
          />
          <AddDriverModal
            show={showAddDriverModal}
            onHide={() => setShowAddDriverModal(false)}
            onSave={handleAddCarrierDriver}
          />
        </>
      ) : (
        <Loading />
      )}
    </LayoutWithSidebar>
  );
};

export default DriversSettings;
